import { createSlice } from "@reduxjs/toolkit";

const countrySlice = createSlice({
  name: "country",
  initialState: { code: "", isEuro: false },
  reducers: {
    setCountry: (state, action) => { state.code = action.payload || ""; },
    setIsEuro: (state, action) => { state.isEuro = Boolean(action.payload); },
  },
});

export const { setCountry, setIsEuro } = countrySlice.actions;
export default countrySlice.reducer;
